import { FC } from "react";
import { FormattedMessage } from "react-intl";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import "./errorBoundary.css";

const ErrorElement: FC = () => {
    return (
        <div className="error-boundary-wrapper">
            <div className="error-boundary-container">
                <div>
                    <ReportProblemIcon style={{ fontSize: "5.5rem" }} />
                </div>
                <h1 className="error-boundary-heading">
                    <FormattedMessage id="error-page.title.oops-something-went-wrong" defaultMessage="Ooops! Something went wrong." />
                </h1>
                <h5 className="error-boundary-heading">
                    <FormattedMessage
                        id="error-page.subtitle.did-not-load-message"
                        defaultMessage="This page didn't load the content correctly. See the JavaScript console for technical details."
                    />
                </h5>
            </div>
        </div>
    );
};

export default ErrorElement;
